<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs :breadcrumbs="page.breadcrumbs" :class="page.headingImage ? '' : 'no-slider'" />

		<main-content>
			<template #content>
				<div class="columns column6">
					<h1>{{ page.title || page.header }}</h1>
					<p v-if="page.bookingID">
						<book-button v-if="page.bookingID" :packageid="page.bookingID" class="button button-accent">
							<span>{{ $t('bookThisPackage') }}</span>
						</book-button>
					</p>
				</div>
				<div class="columns column6">
					<div v-parse-links v-html="page.content" />
				</div>
			</template>
		</main-content>

		<section class="main-content background-light align-left">
			<div class="row">
				<div class="columns column6">
					<div v-parse-links v-html="page.details" />
					<picture>
						<source v-if="page.sideImageWebp" :srcset="page.sideImageWebp" type="image/webp" />
						<source :srcset="page.sideImage" />
						<img :src="page.sideImage" class="extra-image" loading="lazy" :alt="page.sideImageAlt" />
					</picture>
				</div>
				<div class="columns column5 right package-icons">
					<div v-for="item in page.extras" :key="item.id" class="package-icon">
						<font-awesome-icon :icon="`fal fa-${item.icon}`" size="1x" />
						<span>{{ item.content }}</span>
					</div>
				</div>
			</div>
		</section>

		<section class="package-prefooter">
			<div class="row align-center">
				<div class="columns column12">
					<div v-parse-links v-html="page.bannerContent" />
					<book-button v-if="page.bookingID" :packageid="page.bookingID" class="button cta">
						<span>{{ $t('bookThisPackage') }}</span>
					</book-button>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();

await fetchPage();
</script>

<style lang="scss">
.package-prefooter {
	padding: 50px 0;
	background: var(--contentblock-background-color);
	color: #fff;
}

.package-prefooter h2 {
	color: #fff;
}

.extra-image {
	width: 100%;
	max-width: 600px;
	margin: 20px auto 0;
}

.package-icons {
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: stretch;
}

.package-icon {
	width: 46%;
	background: #fff;
	padding: 40px 30px;
	display: flex;
	flex-wrap: wrap;
	justify-content: center;
	text-align: center;
	margin: 10px auto;
}

.package-icon i,
.package-icon svg {
	color: var(--contentblock-background-color);
	font-size: 66px;
	margin: 0 auto 40px;
}

.package-icon span {
	width: 100%;
	font-size: 18px;
}

@media (max-width: 920px) {
	.package-icons {
		width: 100%;
	}
}

@media (max-width: 680px) {
	.package-icon {
		padding: 30px 20px;
		width: 48%;
	}

	.package-icon i,
	.package-icon svg {
		font-size: 58px;
	}

	.package-icon span {
		font-size: 16px;
	}
}
</style>
